var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthenticationMethodType, AuthenticationReason, AuthenticationResult, AuthenticationStatus } from '@mc-alberta/types';
import { AuthenticationStrategy } from '../../types/enums/AuthenticationStrategy';
import { Adapter } from '../Adapter';
import { KpiOperation } from '../../types/enums/KpiOperation';
import { Kpi } from '../../loggers/Kpi';
export class MdesAdapter extends Adapter {
    constructor(params) {
        super(params);
        this.strategy = AuthenticationStrategy.MDES;
        this.supportedReasons = [
            AuthenticationReason.ENROL_FINANCIAL_INSTRUMENT,
            AuthenticationReason.CARD_VERIFICATION,
            AuthenticationReason.CONSUMER_IDENTITY_VALIDATION
        ];
        /**
         * Initializes an MDES session.
         * This requires that an authentication method be selected.
         */
        this.initializeSession = () => __awaiter(this, void 0, void 0, function* () {
            this.isIdentityVerificationPerformed = false;
            if (this.authenticationMethod) {
                this.kpi.start(KpiOperation.INITIATE_AUTHENTICATION);
                yield this.refreshSession();
                if (this.authenticationStatus === AuthenticationStatus.PENDING) {
                    this.authenticationStatus = AuthenticationStatus.PENDING_CHALLENGE;
                }
            }
            else if (this.authenticationMethods.length > 1) {
                this.authenticationStatus = AuthenticationStatus.PENDING_METHOD_SELECTION;
            }
            return this.getSession();
        });
        /**
         * Stores the six-digit OTP entry.
         */
        this.provideChallenge = (otpValue) => {
            this.kpi.start(KpiOperation.PROVIDE_AUTHENTICATION_CHALLENGE);
            this.otpValue = otpValue;
            return this.getSession();
        };
        /**
         * Validates the six-digit OTP value.
         */
        this.validateSession = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            try {
                this.kpi.start(KpiOperation.COMPLETE_AUTHENTICATION);
                const session = yield this.refreshSession({ otpValue: this.otpValue }, {}, false);
                if (session.authenticationResult === AuthenticationResult.AUTHENTICATED) {
                    this.isIdentityVerificationPerformed = true;
                }
                return session;
            }
            catch (error) {
                const detail = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c[0];
                if ((detail === null || detail === void 0 ? void 0 : detail.source) === 'authenticationMethod.methodAttributes.otpValue') {
                    this.authenticationStatus = detail.reason === 'RETRY_LIMIT_REACHED'
                        ? AuthenticationStatus.CHALLENGE_FAILED // all out of retry attempts
                        : AuthenticationStatus.PENDING_CHALLENGE; // more attempts are possible
                    return this.getSession();
                }
                return this.destroySession(error);
            }
            finally {
                delete this.otpValue;
            }
        });
        /**
         * Returns real-time KPI metadata.
         */
        this.kpiMeta = () => {
            var _a;
            return ({
                cardData: {
                    cardVerificationData: {
                        cardAuthVerificationType: (_a = this
                            .authenticationMethod) === null || _a === void 0 ? void 0 : _a.authenticationMethodType,
                        consentSMSAuthVerificationSupported: this
                            .authenticationMethods
                            .some(method => method.authenticationMethodType === AuthenticationMethodType.SMS_OTP),
                        consentEMAILAuthVerificationSupported: this
                            .authenticationMethods
                            .some(method => method.authenticationMethodType === AuthenticationMethodType.EMAIL_OTP)
                    }
                }
            });
        };
        this.kpi = new Kpi(params, this.kpiMeta.bind(this));
    }
}
//# sourceMappingURL=index.js.map